module.exports = __webpack_public_path__ + "img/pic_ranking_one.c7e321f9.png";